import axios from "../lib/axios";

export const createMaintainer = async (data) => {
  try {
    const response = await axios.post("/maintainer/create", data);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create message"
    );
  }
};

export const loginMaintainer = async (data) => {
  try {
    const response = await axios.post("/maintainer/login", data);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create message"
    );
  }
};

export const getMaintainerAll = async () => {
  try {
    const response = await axios.get("/maintainer/get-all");
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create message"
    );
  }
};

export const getMaintainer = async (id) => {
  try {
    const response = await axios.get(`/maintainer/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create message"
    );
  }
};

export const updateMaintainer = async (id, payload) => {
  try {
    const response = await axios.put(`/maintainer/${id}`, payload);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create message"
    );
  }
};

export const deleteMaintainer = async (id) => {
  try {
    const response = await axios.delete(`/maintainer/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create message"
    );
  }
};

export const getUserModuleBasedPermissions = async (module, userId) => {
  try {
    const response = await axios.get(`/maintainer/module/${module}/${userId}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create message"
    );
  }
};
